import { useCallback } from 'react';

let HapticsPlugin = null;
try {
  const { Haptics, ImpactStyle, NotificationType } = require('@capacitor/haptics');
  HapticsPlugin = { Haptics, ImpactStyle, NotificationType };
} catch {
  // Web environment — haptics not available
}

const isNative = typeof window !== 'undefined' &&
  window.Capacitor?.isNativePlatform?.();

/**
 * Provides native haptic feedback on Capacitor (Android/iOS).
 * Silently no-ops on web.
 */
export const useHaptics = () => {
  const impact = useCallback((style = 'Medium') => {
    if (!isNative || !HapticsPlugin) return;
    try {
      HapticsPlugin.Haptics.impact({ style: HapticsPlugin.ImpactStyle[style] });
    } catch { /* ignore */ }
  }, []);

  const notification = useCallback((type = 'Success') => {
    if (!isNative || !HapticsPlugin) return;
    try {
      HapticsPlugin.Haptics.notification({ type: HapticsPlugin.NotificationType[type] });
    } catch { /* ignore */ }
  }, []);

  const selectionClick = useCallback(() => {
    if (!isNative || !HapticsPlugin) return;
    try {
      HapticsPlugin.Haptics.selectionClick();
    } catch { /* ignore */ }
  }, []);

  return { impact, notification, selectionClick, isNative };
};

export default useHaptics;
